// Generic responses from the Rails ErrorsController (config.exceptions_app = routes).
// Emitted when a request falls through to the global /404, /406, or /422 handler —
// the application could not act on it, so the front-end cannot either. Extracted
// from `is-relevant-browser-error` to keep that file under its line budget.
//
// Shape-match, not exact-string: the ErrorsController now appends an `exception`
// class to the body (e.g. {"error":"unprocessable_entity",
// "exception":"ActionController::InvalidAuthenticityToken"}) so the frontend
// withCsrfRetry can recognize CSRF-shaped 422s. That extra key broke the prior
// exact-string allow-list, un-suppressing every generic 404/406/422 and flooding
// Honeybadger. The `exception` key is informational and must not defeat
// suppression. Still narrow: the `error` value must be an allow-listed generic key
// (app-specific bodies like {"error":"Order not found"} report), and any key beyond
// `error`/`exception` forces a report.
//
// @param {string} body — stringified response body (from `toResponseBodyString`).
// @returns {boolean} — true if the notice is a generic ErrorsController body.
const GENERIC_ERROR_VALUES = new Set(["not_found", "unprocessable_entity", "not_acceptable"]);
const ALLOWED_KEYS = new Set(["error", "exception"]);

const isRailsGenericErrorBody = body => {
  if (typeof body !== "string") return false;
  const trimmed = body.trim();
  if (!trimmed.startsWith("{")) return false;
  let parsed;
  try {
    parsed = JSON.parse(trimmed);
  } catch {
    return false;
  }
  if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return false;
  if (!GENERIC_ERROR_VALUES.has(parsed.error)) return false;
  return Object.keys(parsed).every(key => ALLOWED_KEYS.has(key));
};

export default isRailsGenericErrorBody;
